import { render, staticRenderFns } from "./MenuPos.vue?vue&type=template&id=5db0ff47&scoped=true"
var script = {}
import style0 from "./MenuPos.vue?vue&type=style&index=0&id=5db0ff47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0ff47",
  null
  
)

export default component.exports